import { Metric } from './metrics';

export class ErroredInputDataDefinitionResult {
  constructor(
    public id: Metric,
    public errorMessage: string
  ) {}
  isSuccess = false;
}
